import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "appHistory" }

import { ref, watchEffect } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import { dayjs } from "@arco-design/web-vue/es/_utils/date";
import {
  deleteChartUsingPost,
  getChartVoPageUsingPost,
} from "@/api/chartController";
import ChartDetailModal from "@/views/chart/components/ChartDetailModal.vue";
import { CHART_STATUS_MAP, getChartColor } from "@/constant/chart";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChartHistoryPage',
  setup(__props) {

const columns = [
  {
    title: "分析名称",
    slotName: "chartName",
    align: "center",
    width: 250,
  },
  {
    title: "图表类型",
    dataIndex: "chartType",
    align: "center",
    width: 200,
  },
  {
    title: "图表状态",
    slotName: "chartStatus",
    align: "center",
    width: 100,
  },
  {
    title: "分析时间",
    slotName: "createTime",
    align: "center",
    width: 200,
  },
  {
    title: "操作",
    slotName: "optional",
    align: "center",
    width: 200,
  },
];
// 初始化搜索条件
const initSearchParams = {
  current: 1,
  pageSize: 10,
};
const searchParams = ref<API.ChartQueryRequest>({
  ...initSearchParams,
});
const total = ref<number>(0);
const historyData = ref<API.ChartVO[]>();

const loadData = async () => {
  const res = await getChartVoPageUsingPost({
    ...searchParams.value,
  });
  if (res.data.code === 200) {
    historyData.value = res.data.data?.records as any;
    total.value = res.data.data?.total as any;
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};
const onPageSizeChange = (pageSize: number) => {
  searchParams.value = {
    ...searchParams.value,
    pageSize,
  };
};
const handleDelete = async (id: string) => {
  const res = await deleteChartUsingPost({
    id: id as any,
  });
  if (res.data.code === 200) {
    loadData();
    message.success("删除成功");
  } else {
    message.error("删除失败，" + res.data.message);
  }
};
watchEffect(() => {
  loadData();
});
const chartDetailModal = ref();
const handleDetail = (data: API.ChartVO) => {
  chartDetailModal.value.openModal(data);
};

return (_ctx: any,_cache: any) => {
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_table, {
      columns: columns as any,
      data: historyData.value,
      pagination: {
        showTotal: true,
        pageSize: searchParams.value.pageSize,
        current: searchParams.value.current,
        total: total.value,
        showPageSize: true,
      },
      onPageChange: onPageChange,
      onPageSizeChange: onPageSizeChange
    }, {
      chartName: _withCtx(({ record }) => [
        _createVNode(_component_a_link, {
          onClick: ($event: any) => (handleDetail(record))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(record.chartName), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      createTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(dayjs)(record.createTime).format("YYYY-MM-DD HH:mm:ss")), 1)
      ]),
      chartStatus: _withCtx(({ record }) => [
        _createVNode(_component_a_tag, {
          color: _unref(getChartColor)(record.chartStatus)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(CHART_STATUS_MAP)[record.chartStatus]), 1)
          ]),
          _: 2
        }, 1032, ["color"])
      ]),
      optional: _withCtx(({ record }) => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: ($event: any) => (handleDetail(record))
        }, {
          default: _withCtx(() => [
            _createTextVNode("查看")
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_component_a_button, {
          status: "danger",
          onClick: ($event: any) => (handleDelete(record.id))
        }, {
          default: _withCtx(() => [
            _createTextVNode("删除")
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["columns", "data", "pagination"]),
    _createVNode(ChartDetailModal, {
      ref_key: "chartDetailModal",
      ref: chartDetailModal
    }, null, 512)
  ]))
}
}

})